import { FormattedMessage } from "react-intl";
import { Typography } from "@/shared/ui/Typography";
import { BRAND_TEXT_PRIMARY, BRAND_TEXT_SECONDARY } from "@/styles/colorsJS";

export function Header() {
  return (
    <div className="flex-col-gap-4">
      <Typography as="h2" type="h1" color={BRAND_TEXT_PRIMARY}>
        <FormattedMessage defaultMessage="Подписание и уведомления" />
      </Typography>
      <Typography as="p" color={BRAND_TEXT_SECONDARY}>
        <FormattedMessage
          defaultMessage="Договор факторинга и заявление работодателю подписываются онлайн через
        облачную ЭЦП. Уведомление работодателю направляется по email через
        Infobip, статусы доставки фиксируются в личном кабинете и CRM"
        />
      </Typography>
    </div>
  );
}
